import dynamic, { DynamicOptions } from 'next/dynamic'
import { logger } from '@/utils/logging'
import { WeeklyCountdownTimerProps } from '@/views/PreSales/PreSalesGiveawayView/components/Hero/WeeklyCountdownTimer/WeeklyCountdownTimer'

export const WeeklyCountdownTimer = dynamic(
  import('./WeeklyCountdownTimer')
    .then((mod) => mod.WeeklyCountdownTimer)
    .catch((err) =>
      logger().error(`Failed to load the RedeemCollectibleGiftView!`, err),
    ) as DynamicOptions<WeeklyCountdownTimerProps>,
  { ssr: false },
)
